module.exports = __webpack_public_path__ + "img/banner-TV-3__lg.ae6f8657.jpg";